import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  clip-path: polygon(0 0, 100% 0, 100% 200%, 0 200%);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  justify-content: center;
  align-content: center;
  display: flex;
  padding: 16px;
  height: 100px;
  width: 100%;
`;

export const Main = styled.div`
  padding: 16px;
  overflow: hidden;
  margin-top: 26px;
  flex: 1;
`;
